import React from "react";
import "./certification.css";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { LiaCertificateSolid } from "react-icons/lia";

const certifications = [
  {
    title: "Python Programming",
    provider: "Infosys SpringBoard",
    date: "03-08-2023",
    link: "https://drive.google.com/file/d/1GmucjvjuAdVKGqZKklYy37JZb_Le1dYh/view?usp=drivesdk",
  },
  {
    title: "Full Stack Web Development",
    provider: "Udemy",
    date: "01-11-2023",
    link: "https://www.udemy.com/certificate/UC-77025406-2261-469d-88b1-0eec108f85de/",
  },
  {
    title: "Git & GitHub",
    provider: "Infosys Spring Board",
    date: "07-12-2023",
    link: "https://drive.google.com/file/d/1k3EPF3e2ZfUaN7wgInbMlyI5LzvxrFTc/view?usp=drive_link",
  },
  {
    title: "SQL",
    provider: "IBM",
    date: "19-01-2024",
    link: "https://courses.cognitiveclass.ai/certificates/208f24d85cfb47aabc278f09c6bb19fd",
  },
];

const openInPopup = (url) => {
  const width = 600;
  const height = 600;
  const left = (window.innerWidth - width) / 2;
  const top = (window.innerHeight - height) / 2;
  window.open(
    url,
    "_blank",
    `width=${width},height=${height},top=${top},left=${left}`
  );
};

const Certification = () => {
  return (
    <div className="container education cer" id="certification">
      <h2 className="col-12 mt-3 mb-1 text-center text-uppercase">
        Courses & Certification
      </h2>
      <hr />
      <VerticalTimeline>
        {certifications.map((cert, index) => (
          <VerticalTimelineElement
            key={index}
            className="vertical-timeline-element--work"
            contentStyle={{ background: "#F0ECE5", color: "black" }}
            contentArrowStyle={{ borderRight: "7px solid purple" }}
            date={<strong>{cert.date}</strong>}
            iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
            icon={<LiaCertificateSolid />}
          >
            <h3 className="vertical-timeline-element-title">{cert.title}</h3>
            <h4 className="vertical-timeline-element-subtitle">
              By {cert.provider}
            </h4>
            <br />
            <button
              className="ad-btn2 text-center"
              onClick={() => openInPopup(cert.link)}
            >
              <strong>Certificate</strong>
            </button>
          </VerticalTimelineElement>
        ))}
      </VerticalTimeline>
    </div>
  );
};

export default Certification;
